var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.05131 1.05025C1.31586 0.785704 1.74478 0.785704 2.00933 1.05025L6.00106 5.04198L9.99279 1.05025C10.2573 0.785704 10.6863 0.785704 10.9508 1.05025C11.2154 1.3148 11.2154 1.74372 10.9508 2.00827L6.95907 6L10.9508 9.99173C11.2154 10.2563 11.2154 10.6852 10.9508 10.9497C10.6863 11.2143 10.2573 11.2143 9.99279 10.9497L6.00106 6.95802L2.00933 10.9497C1.74478 11.2143 1.31586 11.2143 1.05131 10.9497C0.786761 10.6852 0.786761 10.2563 1.05131 9.99173L5.04304 6L1.05131 2.00827C0.786761 1.74372 0.786761 1.3148 1.05131 1.05025Z",
    fill: "#060606",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseVideo);
export default __webpack_public_path__ + "static/media/closeVideo.73c8a79c591068503b09f691469f86f4.svg";
export { ForwardRef as ReactComponent };